import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  StyledContainerItems,
  StyledTitleSideBar,
  StyledContainerFooterSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../i18n';
import { SideBarEditablePropertyItem } from '../../../components/commons/SideBarComponents/EditablePropertyItem/sideBarEditablePropertyItem';
import { usePostNoteMutation } from '../../../services/notes/notesService';
import { ButtonStyled } from '../../device/addDeviceToLocation/addDeviceToLocationStyles';
import { severityEnum } from '../../../constants/commonEnums';

interface CreateNoteBarProps {
  closeSideBar: () => void;
  id:
    | null
    | {
        deviceId?: number | string;
      }
    | {
        locationId: number;
      }
    | {
        userId: number;
      };
  type: string;
  reloadTable: () => void;
}
export const CreateNoteBar = ({
  closeSideBar,
  reloadTable,
  id,
  type
}: CreateNoteBarProps) => {
  const [note, setNote] = useState('');

  const [createNote, { isSuccess, isLoading }] = usePostNoteMutation();
  useEffect(() => {
    if (isSuccess) {
      reloadTable();
      toast.success(Strings.notes.successNote);
      closeSideBar();
    }
  }, [isSuccess]);

  const sendNote = () => {
    if (!id) return;

    const baseNote = {
      text: note,
      type: type.slice(0, -1),
      severityLevel: severityEnum.low
    };

    let data:
      | {
          deviceId: number | string;
          text: string;
          type: string;
          severityLevel: severityEnum;
        }
      | {
          locationId: number;
          text: string;
          type: string;
          severityLevel: severityEnum;
        }
      | {
          userId: number;
          text: string;
          type: string;
          severityLevel: severityEnum;
        };

    if ('deviceId' in id) {
      data = { ...baseNote, deviceId: id.deviceId! };
    } else if ('locationId' in id) {
      data = { ...baseNote, locationId: id.locationId };
    } else if ('userId' in id) {
      data = { ...baseNote, userId: id.userId };
    } else {
      return;
    }

    createNote(data);
  };
  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>{Strings.notes.createNote}</StyledTitleSideBar>
        <SideBarEditablePropertyItem
          item={{
            label: Strings.notes.createNote,
            type: 'inputText',
            currentValue: note,
            placeholder: Strings.notes.addNote,
            onChange: (
              e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => setNote(e.target.value.toString())
          }}
        />
      </StyledContainerItems>
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => closeSideBar()}
        >
          {Strings.common.cancel}
        </button>
        <ButtonStyled
          disabled={!note}
          variant="contained"
          loading={isLoading}
          size="large"
          onClick={sendNote}
          className="btn-save"
        >
          {Strings.common.save}
        </ButtonStyled>
      </StyledContainerFooterSideBar>
    </>
  );
};
